<template>
  <market>
    <section>
      <div class="row px-5">
        <div class="col-md-5 grid-margin stretch-card">
          <div class="card">
            <div class="card-body px-0">
              <h4>KOEE 1.0</h4>

              <div class="row align-items-center justify-content-center d-flex h-100">
                <youtube
                  ref="youtube"
                  :video-id="videoId"
                  :fit-parent="true"
                  :resize="true"
                ></youtube>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-7 grid-margin stretch-card">
          <box-features></box-features>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="page-header">
            <p class="page-title"></p>
            <div class="col-lg-3 col-md-12">
              <new-request-modal
                modal-id="callme-request-modal"
                direction="SAL"
              ></new-request-modal>
              <b-btn
                v-b-modal="'callme-request-modal'"
                variant="info"
                class="btn-icon-text ml-1 w-100"
                @click="callMe"
              >
                {{ $t('button.callMe.label') }}
              </b-btn>
            </div>
          </div>
        </div>
      </div>
    </section>
  </market>
</template>

<script>
export default {
  name: 'MarketBoxes',
  data() {
    return {
      videoId: 'y0-sYJSPbI8',
    };
  },
  methods: {
    callMe() {},
  },
};
</script>

<style></style>
